import { RightSizingReportFieldsFragment } from '@api/gql/graphql';
import { Stack } from '@mui/material';
import { getFragmentData } from '@api/gql';
import { ACCESS_FLOW_METRICS_FRAGMENT, AccessFlowUsageMetricValue_Fragment } from '@AccessRightSizing/services/gql';
import { DURATION_METRIC, METRIC_TYPE_LABELS, MetricType } from '@AccessRightSizing/common/constants';
import { SECONDS_TO_HOURS, secondsToHours } from '@AccessRightSizing/common/common';
import MetricsBox from '@common/ui/MetricBox';

export function AccessRightSizingMetrics({
  rightSizingReport,
}: {
  rightSizingReport: RightSizingReportFieldsFragment;
}) {
  const metrics = getFragmentData(ACCESS_FLOW_METRICS_FRAGMENT, rightSizingReport.metrics);

  return (
    <Stack direction="row" spacing={2}>
      {metrics.map((metric) => {
        const current = getFragmentData(AccessFlowUsageMetricValue_Fragment, metric.currentValue);
        const previous = getFragmentData(AccessFlowUsageMetricValue_Fragment, metric.previousValue);

        let changeValue = previous ? current.notUsed - previous?.notUsed : undefined;
        const changePercentage =
          changeValue && previous ? parseFloat(((changeValue / previous?.notUsed) * 100).toFixed(0)) : 0;
        let mainValue = '';
        if (DURATION_METRIC === metric.metricType) {
          if (changeValue !== undefined) {
            changeValue = changeValue === 0 ? 0 : changeValue / SECONDS_TO_HOURS;
          }
          mainValue = current.notUsed != 0 ? secondsToHours(current.notUsed) : '0 minutes';
        } else {
          mainValue =
            current.defined !== 0
              ? parseFloat(((current.notUsed / current.defined) * 100).toFixed(1)).toString() + '%'
              : 'None defined';
        }

        const title = getLabel(metric.metricType);
        return (
          <MetricsBox
            key={metric.metricType}
            title={title}
            changeValue={changeValue}
            changePercentage={changePercentage}
            mainValue={mainValue}
            timePeriod="During defined period"
          />
        );
      })}
    </Stack>
  );
}

const getLabel = (key: string): string => {
  if (key in METRIC_TYPE_LABELS) {
    return METRIC_TYPE_LABELS[key as MetricType];
  }
  return 'Unknown metric type';
};
